import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import EcCommon from '../../../types/ec/ecCommon';

export const PersonServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl + 'person-api/v1',
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey,
	},
});

export default class PersonService extends ApiService implements EcCommon.IPersonService {
	constructor() {
		super('person-service', PersonServiceAxiosInstance);
	}

	public getPersonRoles(applicationId: string, roleId: string): AxiosPromise<EcCommon.IEmployeeUser[]> {
		return this.axiosInstance.get('/employeeuser/application/' + applicationId + '/role/' + roleId);
	}
}

export const personService = new PersonService();
